<ng-container>
  <div class="system-upgrade">
    <h1>{{ 'systemUpgrade.upgradeTitle' | translate }}</h1>
    <div class="app-content">
      <frodo-logo
        class="main-logo"
        [src]="'../../assets/logo-icon.svg'"
        [alt]="'logo'"
      ></frodo-logo>
      <ng-container *ngIf="systemUpgrade$ | async as systemUpgrade">
        <h2
          *ngIf="systemUpgrade.state === systemUpgradeState.FAILED; else subtitle"
          class="error-message"
        >
          {{ systemUpgrade.message }}
        </h2>
        <ng-template #subtitle>
          <h2>{{ 'systemUpgrade.upgradeSubtitle' | translate }}</h2>
        </ng-template>
      </ng-container>
    </div>
    <frodo-logo class="apex-logo" [src]="'../../assets/logo.png'" [alt]="'logo'"></frodo-logo>
  </div>
</ng-container>
